import {
  AVAILABLE_LEGAL_COUNTRY_CODES,
  type AvailableLegalCountryCode,
} from '@repo/shared-config/app/constants/countries';
import { type CountryCode, DEFAULT_COUNTRY_CODES } from '../constants/countries';

const countryCodeSet = new Set<string>(DEFAULT_COUNTRY_CODES);

export function isCountryCode(value: string): value is CountryCode {
  return countryCodeSet.has(value);
}

export function toCountryCode(value: string | null | undefined): CountryCode | null {
  if (typeof value !== 'string' || !isCountryCode(value)) return null;
  return value;
}

export function toCountryCodes(values: string[] | null | undefined): CountryCode[] {
  if (!values) return [];
  return values.filter(isCountryCode);
}

const availableLegalCountryCodeSet = new Set<string>(AVAILABLE_LEGAL_COUNTRY_CODES);

export function isAvailableLegalCountryCode(value: string): value is AvailableLegalCountryCode {
  return availableLegalCountryCodeSet.has(value);
}

export function toAvailableLegalCountryCode(
  value: string | null | undefined
): AvailableLegalCountryCode | null {
  if (typeof value !== 'string' || !isAvailableLegalCountryCode(value)) return null;
  return value;
}
